import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { Image } from '@/components/ui/image';
import Reveal from '@/components/Reveal';
import Flag from '@/components/Flag';
import { ROSTER } from '@/data/roster';

export default function TalentRoster() {
  return (
    <section id="roster" className="bg-[#0B0B0B] py-24 lg:py-32">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
        <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#3B82F6] mb-4 block">
              Our Roster
            </span>
            <h2
              className="font-display font-bold text-white tracking-tight leading-tight"
              style={{ fontSize: 'clamp(2rem, 4vw, 3.25rem)' }}
            >
              The Talent Roster
            </h2>
          </div>
          <p className="text-white/50 font-light max-w-sm leading-relaxed">
            A diverse international portfolio of ten creators, each dominant within a distinct
            cultural and commercial vertical. Select any profile for full detail.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5 lg:gap-6">
          {ROSTER.map((m, i) => (
            <Reveal key={m.slug} delay={(i % 5) * 0.07}>
              <Link
                to={`/talent/${m.slug}`}
                className="group block h-full rounded-lg overflow-hidden border border-white/10 bg-[#121212] hover:border-[#3B82F6]/70 hover:-translate-y-1 transition-all duration-500"
              >
                <div className="relative aspect-[3/4] overflow-hidden">
                  <Image
                    src={m.img}
                    alt={`${m.name}, ${m.country}`}
                    fittingType="fill"
                    quality={70}
                    className="w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-[1.06]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0B] via-transparent to-transparent opacity-75" />
                  <div className="absolute top-3 right-3 w-8 h-8 rounded-lg bg-[#2563EB] flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    <ArrowUpRight className="w-4 h-4 text-white" />
                  </div>
                  <div className="absolute bottom-3 left-4 right-4">
                    <p className="text-[10px] uppercase tracking-[0.16em] text-white/70">{m.city}</p>
                  </div>
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-2">
                    <Flag code={m.code} className="w-5 h-3.5" />
                    <h3 className="font-display font-semibold text-base lg:text-lg text-white group-hover:text-[#3B82F6] transition-colors">
                      {m.name}
                    </h3>
                  </div>
                  <p className="text-xs text-white/45 mt-2 leading-relaxed">{m.specialization}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}